import { SEARCH_PAGE_SIZE } from "../constants/CommonConstants";
import { TESTING_SCOPE_SEARCH_START_LOADING, TESTING_SCOPE_SEARCH_END_LOADING, TESTING_SCOPE_SEARCH_LOADED, SET_TESTING_SCOPE_FILTER } from "../constants/IneTestingScopeConstants";
import { TESTING_SCOPE_START_LOADING, TESTING_SCOPE_END_LOADING, TESTING_SCOPE_LOADED } from "../constants/IneTestingScopeConstants";

const initialState = {
    loading: false,
    list: {   
        dataList: []
        , searchList: []
        , totalCount: 0
    },
    filter: {
        pageIndex: 1,
        pageSize: SEARCH_PAGE_SIZE,
        search: "",
        active: ""
    },
    loadingFBO: false,
    fbo: null,
};

const IneTestingScopeReducer = (state = initialState, action) => {
    switch(action.type) {
        case TESTING_SCOPE_SEARCH_START_LOADING:
            return {
                ...state,
                loading: true
            };
        case TESTING_SCOPE_SEARCH_END_LOADING:
            return {
                ...state,
                loading: false
            };
        case TESTING_SCOPE_SEARCH_LOADED:
            return {
                ...state,
                list: action.payload
            };
        case SET_TESTING_SCOPE_FILTER:
            return {
                ...state,
                filter: action.payload
            };
        case TESTING_SCOPE_START_LOADING:
            return {
                ...state,
                loadingFBO: true
            };
        case TESTING_SCOPE_END_LOADING:
            return {
                ...state,
                loadingFBO: false
            };
        case TESTING_SCOPE_LOADED:
            return {
                ...state,
                fbo: action.payload
            };
        default:
            return state;
    }
}

export default IneTestingScopeReducer;